module.exports = __webpack_public_path__ + "static/media/message.37720353.svg";